import { formatQuotedPrice } from "@shared-core/domain/formatters";
import { Button } from "../../app/components/primitives/button";

// The totals block of the summary beside a quote or an order (QuoteDecision.tsx, OrderSummaryPanel.tsx): the
// total not including VAT, the VAT and the total including VAT, one under the other, with a way to the price line
// by line. A total not known yet (a quote still waiting on a choice) shows a dash, and the VAT lines are left out
// until both totals are known.

export function SummaryTotals({
  heading,
  exVatPence,
  incVatPence,
  onOpenPrice,
  note = null,
}: {
  heading: string;
  /** Null: not known yet. */
  exVatPence: number | null;
  /** Null when a price has no VAT-inclusive figure. */
  incVatPence: number | null;
  /** Absent: no link (the page has no price-by-line view to open). */
  onOpenPrice?: () => void;
  /** What the totals leave out, under them ("Delivery not yet priced"); null says nothing. */
  note?: string | null;
}) {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">{heading}</p>
      <dl className="grid grid-cols-[1fr_auto] gap-x-4 gap-y-1 text-sm tabular-nums">
        <dt className="text-muted-foreground">Total, not including VAT</dt>
        <dd className="text-right font-semibold">
          {exVatPence !== null ? formatQuotedPrice(exVatPence) : "—"}
        </dd>
        {exVatPence !== null && incVatPence !== null && (
          <>
            <dt className="text-muted-foreground">VAT</dt>
            <dd className="text-right">
              {formatQuotedPrice(incVatPence - exVatPence)}
            </dd>
            <dt className="border-t pt-1 font-medium">Total including VAT</dt>
            <dd className="border-t pt-1 text-right font-semibold">
              {formatQuotedPrice(incVatPence)}
            </dd>
          </>
        )}
      </dl>
      {note && <p className="text-xs text-muted-foreground">{note}</p>}
      {onOpenPrice && (
        <Button
          variant="link"
          size="sm"
          className="h-auto p-0 text-xs"
          onClick={onOpenPrice}
        >
          See the price line by line ›
        </Button>
      )}
    </div>
  );
}
